        <button  class="btn btn-primary "  (click)="printDiv()">
    <i  class="fa fa-print" style="font-size:unset !important;"></i>&nbsp;{{ 'Print' | translate}}</button>
<div id="printpage">
</div>